<template>
  <b-row>
    <b-col cols="12">
      <vacancy-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import VacancyEditForm from './VacancyEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    VacancyEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
